import { Marquee } from '@/components/dashboard/fx/Marquee'

interface NameMarqueeProps {
  words: string[]
  reverse?: boolean
  duration?: number
  compact?: boolean
}

// Alternating solid / dimmed uppercase names separated by stars.
export function NameMarquee({ words, reverse, duration = 70, compact }: NameMarqueeProps) {
  return (
    <Marquee reverse={reverse} duration={duration}>
      {words.map((word, i) => (
        <span key={`${word}-${i}`} className="flex items-center">
          <span
            className={`px-5 font-display font-semibold uppercase leading-none tracking-tight ${
              compact ? 'text-[clamp(1.75rem,3.6vw,3rem)]' : 'text-[clamp(2.5rem,6vw,5rem)]'
            } ${i % 2 ? 'text-foreground/25' : ''}`}
          >
            {word}
          </span>
          <span className="text-xl text-primary">✦</span>
        </span>
      ))}
    </Marquee>
  )
}
